import { render, staticRenderFns } from "./comment-list.vue?vue&type=template&id=7df34a0c&"
import script from "./comment-list.vue?vue&type=script&lang=ts&"
export * from "./comment-list.vue?vue&type=script&lang=ts&"
import style0 from "./comment-list.vue?vue&type=style&index=0&id=7df34a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports